export const clientLockedMessages = {
  PROFORMA_CALC: 'You are not allowed to start proforma calc while the client is locked',
  BATCH_ADJUSTMENTS_PAGE: 'You are not allowed to batch adjustments while the client is locked',
  RATE_CHANGE_WORKPAPER_PAGE: 'You are not allowed to rate change workpaper while the client is locked',
};
